import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user']),
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover o carro <b>${this.currentEntity.plate}</b>?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/car/resources/computed.js